import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-global-network',
  imports: [TranslateModule],
  templateUrl: './global-network.component.html',
  styleUrl: './global-network.component.scss',
})
export class GlobalNetwork {}
